<script setup>
import NewsletterSection from '@sections/home-page/newsletter.vue'
import { useGlobalStore } from '@stores/global'
import { ref } from 'vue'
import { BASE_URL } from '@constants'

const global = useGlobalStore()

const sitemap = ref([
	{
		label: 'home',
		to: { name: 'home' },
	},
	{
		label: 'products',
		to: { name: 'products' },
	},
	{
		label: 'merch',
		to: { name: 'merch' },
	},
	{
		label: 'about',
		to: { name: 'about' },
	},
	{
		label: 'blog',
		to: { name: 'blog' },
	},
	{
		label: 'contact us',
		to: { name: 'contact' },
	},
])

const legal = ref([
	{
		label: 'Privacy Policy',
		to: { name: 'policyPage', params: { slug: 'privacy' } },
	},
	{
		label: 'Terms of Service',
		to: { name: 'policyPage', params: { slug: 'terms' } },
	},
	{
		label: 'Shipping Policy',
		to: { name: 'policyPage', params: { slug: 'shipping' } },
	},
	{
		label: 'Returns Policy',
		to: { name: 'policyPage', params: { slug: 'returns' } },
	},
])

const date = new Date().getFullYear()

const copyright = ref(`© Garden Mother ${date}, All Rights Reserved.`)
</script>

<template>
	<NewsletterSection />
	<footer class="flex flex-col border-t border-border lg:flex-row">
		<div class="flex w-full flex-row flex-wrap gap-16 p-12 lg:w-half">
			<div class="flex flex-col gap-10">
				<img src="https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/logo-footer.svg" alt="" />
				<div class="flex max-w-[200px] flex-row flex-wrap gap-2" v-if="global.socials.length">
					<a v-for="social in global.socials" :key="social.avatar_url" :href="social.link" :title="`${social.platform?.name} - ${social.username}`" target="_blank" class="flex h-4 w-4 items-center justify-center rounded-full border border-border bg-bgMain p-5 leading-[100%]">
						<i :class="social.platform?.icon" />
					</a>
				</div>
			</div>
			<div class="flex flex-col gap-8">
				<span class="font-bold">Sitemap</span>
				<div class="flex flex-col gap-4 capitalize text-primaryLight">
					<router-link v-for="link in sitemap" :to="link.to">
						{{ link.label }}
					</router-link>
				</div>
			</div>
			<div class="flex flex-col gap-8">
				<span class="font-bold">Legal</span>
				<div class="flex flex-col gap-4 capitalize text-primaryLight">
					<router-link v-for="link in legal" :to="link.to">
						{{ link.label }}
					</router-link>
				</div>
			</div>
		</div>
		<div class="flex w-full flex-col gap-12 border-t border-border p-12 lg:w-half lg:border-l lg:border-t-0">
			<span class="text-primaryLight">{{ copyright }}</span>
			<div class="flex flex-col gap-4">
				<div v-for="contact of global.contacts" class="flex items-center gap-2">
					<i :class="contact.icon" />
					{{ contact.label }}
				</div>
			</div>
		</div>
	</footer>
</template>
